import { isLocalDomain } from './aem-utils';

/**
 * Function for build cookie String
 * @param {string} name cookie name
 * @param {string} value cookie value
 * @param {object} options cookie options
 */
const buildCookieString = (name, value, options) => {
  const parts = [];
  parts.push(`${name}=${value}`);

  if (!isLocalDomain()) {
    if (!options.insecure) {
      parts.push('secure');
    }
  }

  if (options.samesite) {
    parts.push(`samesite=${options.samesite}`);
  } else {
    parts.push('samesite=lax');
  }

  if (options.expires) {
    parts.push(`expires=${options.expires}`);
  }

  if (options.path) {
    parts.push(`path=${options.path}`);
  }

  if (options.domain) {
    parts.push(`domain=${options.domain}`);
  }

  return `${parts.join('; ')};`;
};

/**
 * Set Cookie
 * @param {string} name cookie name
 * @param {string} value cookie value
 * @param {object} options cookie options
 */
export function setCookie(name, value, options = {}) {
  const cookieString = buildCookieString(name, value, options);
  document.cookie = cookieString;
}

/**
 * Get Cookie
 * @param {string} cookieName the name of the cookie
 */
export function getCookie(cookieName) {
  const name = `${cookieName}=`;
  const cookies = document.cookie.split(';');
  return cookies.filter((c) => c.indexOf(name) !== -1).map((c) => c.trim().substring(name.length, c.length))[0];
}

/**
 * Remove cookie
 * @param {string} name the name of the cookie
 * @param {*} options cookie options
 */
export function removeCookie(name, options = {}) {
  if (!options.expires) {
    options.expires = 'Thu, 01 Jan 1970 00:00:01 GMT';
  }

  if (!options.path) {
    options.path = '/';
  }

  document.cookie = buildCookieString(name, '', options);
}

/**
 * expire data for cookie
 */
const currentDate = () => {
  const date = new Date();

  return date;
};

/**
 * expire data for cookie
 * @param {object} arg
 * @param {number} arg.days the duration in days
 * @param {number} arg.hours the duration in hours
 */
export const expireDateGenerator = ({ days = 1, hours = 24 }) => {
  const date = currentDate();

  date.setTime(date.getTime() + days * hours * 60 * 60 * 1000);

  return date.toUTCString();
};
